(function(){
	//replace uppercase to regular case
    angular.module('tmx-app').filter('titleCase', titleCase);

    function titleCase() {
        return function(str) {
            if(str=="Pjp") {
                return "PJP";
            }

            return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        };
    }

})();

